var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5829 13.662C17.6072 13.662 16.7967 13.3106 16.1011 12.5695C15.4033 11.8263 15.0528 10.9353 15.0528 9.84274C15.0528 8.75021 15.4033 7.85921 16.1011 7.11595C16.7967 6.37488 17.6072 6.02354 18.5829 6.02354C19.5586 6.02354 20.369 6.37488 21.0647 7.11595L21.7209 6.49997L21.0647 7.11595C21.7624 7.85921 22.113 8.75021 22.113 9.84274C22.113 10.9353 21.7624 11.8263 21.0647 12.5695C20.369 13.3106 19.5586 13.662 18.5829 13.662ZM10.6227 23.1004V21.0115C10.6227 20.6005 10.7133 20.2125 10.8987 19.8371C11.0766 19.4772 11.3143 19.2104 11.6136 19.0148C12.6477 18.3544 13.7417 17.8607 14.8976 17.5315C16.0552 17.2019 17.2825 17.035 18.5829 17.035C19.8833 17.035 21.1105 17.2019 22.2681 17.5315C23.4241 17.8607 24.5181 18.3544 25.5521 19.0148C25.8515 19.2104 26.0892 19.4772 26.267 19.8371C26.4525 20.2125 26.5431 20.6005 26.5431 21.0115V23.1004H10.6227Z",
    stroke: "white",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15408_3369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05469 14.0665V13.0791H10.7048V14.0665H1.05469Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0828 7.76526H1.05469V6.78955H11.4119C11.2757 7.11317 11.1702 7.43936 11.0828 7.76526Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05469 1.47571V0.5H16.6085V1.47571H1.05469Z",
    fill: "white",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15408_3369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5538,
    height: 14.5664,
    fill: "white",
    transform: "translate(0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerInactive);
export default __webpack_public_path__ + "static/media/customerInactive.b6628b67c46a8d170488b80ea295f75d.svg";
export { ForwardRef as ReactComponent };